module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-sleepy.560be1a0.png";